"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseCouponList = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var coupon_1 = require("../../model/coupon");
var service_1 = require("../../../library/base/service");
var UseCouponList = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(UseCouponList, _super);
    function UseCouponList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '618优惠券列表';
        _this.code = '300203';
        _this.desc = '618优惠券列表';
        _this.requestParams = new coupon_1.UseCouponListRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return UseCouponList;
}(service_1.BaseService));
exports.UseCouponList = UseCouponList;
//# sourceMappingURL=useCouponList.js.map